/**
 *
 * @file CORE script
 * @description required on all builds
 * @copyright JG Media Limited
 * @author JG Media [jgmedia.co.uk]
 * @version 1.0
 * @module core-script
 * @variables coreVariables is generated by wp_localize_script within core-scripts.php
 *
 */

console.log('A JG Media production - jgmedia.co.uk');

coreVariables = coreVariables || {};

//current viewport width
coreVariables.viewPortWidth = window.innerWidth;

/**
 * @function
 * @name Anonymous self-invoked function
 * @param {Object} $ jQuery
 */
(function($) {

    /**
     * enable tooltips everywhere
     * @description enables bootstrap 4 tooltips on all elements with data-toggle="tooltip"
     * @function
     * @name initTooltips
     */
    coreVariables.initTooltips = function() {

        if(jQuery().tooltip) {

            jQuery('[data-toggle="tooltip"]').tooltip();

        }

    };

    /**
     * close poppers
     * @description closes poppers when the body is clicked, or when the element .pop-close is clicked
     * @function
     * @name popperClose
     * @deprecated
     */
    /* coreVariables.popperClose = function() {

        //close popper on body click event listener
        jQuery('body').click(function(e) {

            jQuery('.pop').each(function() {

                //if the pop is visible
                if (jQuery(this).is(":visible ")) {

                    //if the click is on the button itself or the pop, do nothing (otherwise the popper would open then close immediately)
                    if (e.target.classList.contains('pop-trigger') || e.target.classList.contains('pop') || jQuery(e.target).parents('.pop').length || jQuery(e.target).parents('.pop-trigger').length) {

                        return;

                    } else {

                        jQuery(this).hide();

                    }

                }

            });

        });

        //click on the pop-close element
        jQuery('.pop-close').click(function() {

            jQuery(this).parent().hide();

        });

    }; */

    /**
     * replace svg with inline svg
     * @description replace all svg images with embedded svg so we can control the styling with css, requires the image to have the class 'svg'
     * @function
     * @name replaceSVGwithInline
     */
    coreVariables.replaceSVGwithInline = function() {

        console.log('CORE: replaceSVGwithInline triggered');

        jQuery('img.svg').each(function() {

            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (!typeof imgID === 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (!typeof imgClass === 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });

    };

    //

    /**
     * corrects the position of the footer
     * @description if the page is smaller than the screen, increase the height to put the footer at the bottom of the page
     * @function
     * @name footerCorrection
     */
    coreVariables.footerCorrection = function() {

        //add a variable to the page which requires correction
        // if (coreVariables.enableFooterCorrection === true) {

            console.log('CORE: footerCorrection triggered');

            var event = new Event('core-footer-correction-applied');

            var footer = jQuery('footer');
            var footerHeight = footer.outerHeight();
            var main = jQuery('main');
            var footerTop = footer.offset().top;
            var footerBottom = footerTop + footerHeight;
            var viewportTop = jQuery(window).scrollTop();
            var viewportBottom = viewportTop + jQuery(window).height();
            var footerBottomPosition = viewportBottom - footerBottom;

            if (footerBottomPosition > 0) {

                console.log('CORE: footer correction applied');
                main.outerHeight(main.outerHeight() + footerBottomPosition);

                // Dispatch the event.
                window.dispatchEvent(event);

            // }

        }

    };

    /**
     * set and maintain aspect ratio of elements
     * @function
     * @name aspectRatio
     */
    coreVariables.aspectRatio = function() {

        console.log('CORE: aspectRatio triggered');

        //square
        jQuery('.fixed-aspect').each(function() {

            var element = jQuery(this);

            if (element.hasClass('aspect-square')) {

                //set the height to the width
                element.height(Math.ceil(element.width()));

            } else if (element.hasClass('aspect-4-3')) {

                //set the height
                element.height(Math.ceil(element.width() * 0.75));

            } else if (element.hasClass('aspect-16-9')) {

                //set the height
                element.height(Math.ceil(element.width() * 0.5625));

            } else if (element.hasClass('aspect-3-4')) {

                //set the height
                element.height(Math.ceil(element.width() * 1.3333));

            }

        });

    };

    /**
     * set the aspect ratio of all images within a container
     * @function
     * @name containerAspectRatio
     */
    coreVariables.containerAspectRatio = function() {

        console.log('CORE: containerAspectRatio triggered');

        var images = jQuery('.fixed-aspect-parent .fixed-aspect-child');
        var firstImage = images.first();
        var firstImageWidth = Math.ceil(firstImage.width());

        images.each(function() {

            jQuery(this).height(firstImageWidth);

        });

    };

    /**
     * enable select2 drop downs
     * @description adds a search bar to #billing_country & #shipping_country
     * @function
     * @name select2
     */
    coreVariables.select2 = function() {

        if (coreVariables.enableSelect2 && jQuery().select2) {

            console.log('CORE: select2 triggered');

            //https://select2.org/configuration/options-api
            //qm-filter-hooks-name is for query monitor plugin
            jQuery('select').not('#billing_country, #shipping_country, #rating, .qm select, .core-prevent-select2').select2({

                minimumResultsForSearch: -1, //hide the search box
                width: 'style'

            });

            //add the search bar to the shipping drop downs for WC
            jQuery('#billing_country, #shipping_country').select2({

                width: 'style'
            });

        }

    };

    /**
     * matches the height for elements
     * @description uses .matchHeight class
     * @function
     * @name matchHeight
     */
    coreVariables.matchHeight = function() {

        if (coreVariables.enableMatchHeight && jQuery().matchHeight) {

            console.log('CORE: matchHeight triggered');

            jQuery('.match-height').matchHeight({

                byRow: true,
                property: 'height'

            });

            //trigger a custom event when match height is complete (for example to show elements once equal)
            jQuery.fn.matchHeight._afterUpdate = function() {

                jQuery('body').trigger('match-height-complete');

            };

        }

    };

    /**
     * get a query param
     * @function
     * @name getParameterByName
     * @param {String} paramName name of the param
     * @param {String} url the url string
     */
    coreVariables.getParameterByName = function(paramName, url) {

        if (!url) {
            url = window.location.href;
        }

        paramName = paramName.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)');
        var results = regex.exec(url);

        if (!results) {
            return null;
        }

        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    /**
     * show the core modal
     * @param  {string} title
     * @param  {html} body
     */
    coreVariables.triggerModal = function(title, body, showCloseButton = false, closeButtonText = 'Close', showButton = false, buttonText = 'Go', buttonLink = '#') {

        var modal = jQuery('#core-modal');
        modal.find('#modal-title').text(title);
        modal.find('#modal-body').html(body);
        modal.find('#modal-close-button').text(closeButtonText);

        modal.find('#modal-button').text(buttonText);
        modal.find('#modal-button').attr('href', buttonLink);

        if(showCloseButton){

            modal.find('#modal-close-button').show();

        }
        else {

            modal.find('#modal-close-button').hide();

        }
        if(showButton){

            modal.find('#modal-button').show();

        }
        else {

            modal.find('#modal-button').hide();

        }

        jQuery('#core-modal').modal('show');


    }

    /**
     * @listens document.ready
     * @description various functions to fire on document ready
     * @event document/ready
     */
    jQuery(function() {

        //enable tooltips
        if( coreVariables.enableTooltips ) { coreVariables.initTooltips(); }

        //lazy loading
        if( coreVariables.enableLazyLoad ) {

            coreVariables.lazyLoadInstance = new LazyLoad({
                elements_selector: '.lazy',
            });

        }

        //replace svg images with inline
        if( coreVariables.enableInlineSvg ) { coreVariables.replaceSVGwithInline(); }

        //set the aspect ratio of certain images
        if(coreVariables.enableAspectRatio) {

            coreVariables.aspectRatio();
            coreVariables.containerAspectRatio();

        }

        //polyfill for object fit
        if (!typeof objectFitImages === 'undefined') {

            objectFitImages();

        }

        //enable select2
        coreVariables.select2();

        //enable match height
        if( coreVariables.enableMatchHeight) { coreVariables.matchHeight(); }

        //close all poppers on body click
        if( coreVariables.enablePopper ) { coreVariables?.popper?.hideAll(); }

    });

    /**
     * @listens window.load
     * @description various functions to fire on window load
     * @event window/load
     */
    jQuery(window).on('load', function() {

        //correct the position of the footer if above the fold
        // coreVariables.footerCorrection();

        //repeat select2 to catch things like late loading forms such as ninja forms
        coreVariables.select2();

    });

    /**
     * @listens nfFormReady
     * @description various functions to fire on ninja form ready
     * @event nfFormReady
     */
    jQuery(document).on( 'nfFormReady', function() {

        console.log('CORE: ninja form ready');
        coreVariables.select2();

    });

    /**
     * @listens window.resize
     * @description various functions to fire on window resize
     * @event window/resize
     */
    jQuery(function() {

        var timer_id;

        var coreViewportResizeEvent = new Event('core-viewport-resize');
        jQuery(window).on('resize', function() {

            coreVariables.viewPortWidth = window.innerWidth;

            clearTimeout(timer_id);

            timer_id = setTimeout(function() {

                if(coreVariables.enableAspectRatio) {

                    coreVariables.aspectRatio();
                    coreVariables.containerAspectRatio();

                }

                coreVariables.navSwitch();

                if(coreVariables.enableMegaNav) {

                    coreVariables.megaNav();

                }

                window.dispatchEvent(coreViewportResizeEvent)

                // coreVariables.footerCorrection();

            }, 300);
        });
    });

})(jQuery);